/**
 * Using for the "Featured review" blocks of the main product section
 */
if (!customElements.get('product-featured-review')) {
  customElements.define(
    'product-featured-review',
    class ProductFeaturedReview extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          slider: '.featured-review__slider',
          items: '.featured-review__items',
          pagination: '.swiper-pagination',
        };

        this.sectionId = this.dataset.sectionId;
        this.elements = FoxTheme.utils.queryDomNodes(this.selectors, this);

        this.enableSlider = this.dataset.enableSlider === 'true';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        if (!this.elements.slider || !this.elements.items) return;

        this.initSlider();
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.elements.items).getPropertyValue('--featured-review-gap');
        const spaceBetween = columnGap !== '' ? parseFloat(columnGap.replace('rem', '')) * 10 : 16;

        const additionModules = [];

        this.sliderOptions = {
          slidesPerView: 1,
          spaceBetween: spaceBetween,
          autoHeight: true,
          loop: true,
          threshold: 2,
          pagination: {
            el: this.elements.pagination,
            clickable: true,
          },
        };

        const autoplayDelay = parseInt(this.dataset.autoplay);
        if (autoplayDelay > 0) {
          additionModules.push(FoxTheme.Swiper.Autoplay);
          this.sliderOptions = {
            ...this.sliderOptions,
            autoplay: {
              delay: autoplayDelay,
              disableOnInteraction: false,
            },
          };
        }

        this.sliderInstance = new window.FoxTheme.Carousel(this.elements.slider, this.sliderOptions, additionModules);
        this.sliderInstance.init();

        const focusableElements = FoxTheme.a11y.getFocusableElements(this.elements.items);
        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            if (slide) {
              this.sliderInstance.slider.slideToLoop(Number(slide.dataset.index));
            }
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId !== this.sectionId) return;
            const slide = e.target.closest('.swiper-slide');
            if (!slide) return;
            this.sliderInstance.slider.slideToLoop(Number(slide.dataset.index));
          });
        }
      }
    }
  );
}